import { render, staticRenderFns } from "./canvasbox.vue?vue&type=template&id=01d11dce&scoped=true"
import script from "./canvasbox.vue?vue&type=script&lang=js"
export * from "./canvasbox.vue?vue&type=script&lang=js"
import style0 from "./canvasbox.vue?vue&type=style&index=0&id=01d11dce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d11dce",
  null
  
)

export default component.exports